<rt-dialog-header [heading]="'rti.werken_in_een_hotel.name' | translate">
  {{ 'rti.werken_in_een_hotel.create_posting.modal.subtitle' | translate }}
</rt-dialog-header>
<rt-dialog-body layout-vertical>
  <div layout-horizontal layout-align-items-center margin-bottom>
    <rt-label>{{ 'rti.werken_in_een_hotel.update_posting.modal.id' | translate }}</rt-label>
    <span>&nbsp;{{ state.posting.remoteId }}</span>
    @if (state.posting.urls?.nl) {
      <a
        rt-icon-button
        [href]="state.posting.urls!.nl"
        target="_blank"
        [rtTooltip]="'rti.werken_in_een_hotel.update_posting.modal.nl_link_tooltip' | translate"
        iconName="open-in-new"
        shape="square"
        variant="plain"
      >
        <rt-icon name="open-in-new" />
      </a>
    }
    @if (state.posting.urls?.en) {
      <a
        rt-icon-button
        [href]="state.posting.urls!.en"
        target="_blank"
        [rtTooltip]="'rti.werken_in_een_hotel.update_posting.modal.en_link_tooltip' | translate"
        variant="plain"
        iconName="open-in-new"
        shape="square"
      >
      </a>
    }
  </div>

  <rti-werken-in-een-hotel-posting-form
    [posting]="state.posting"
    [postingForm]="postingForm"
    [errorFields]="state.errorFields"
  />
  <rti-error-messages-wrapper [errors]="state.errors" />
</rt-dialog-body>
<rt-dialog-footer [hasOptionalActions]="true">
  <rt-button
    class="optional"
    variant="plain"
    [disabled]="state.saving"
    [loading]="state.removing"
    (click)="remove()"
  >
    {{ 'rti.job_boards.edit_posting.remove' | translate }}
  </rt-button>

  <rt-button variant="plain" [disabled]="state.saving || state.removing" (click)="close()">
    {{ 'rti.common.cancel' | translate }}
  </rt-button>

  <rt-button
    variant="primary"
    [disabled]="!formValid || state.removing"
    [loading]="state.saving"
    (click)="save()"
  >
    {{ 'rti.common.save' | translate }}
  </rt-button>
</rt-dialog-footer>
